/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../common/BaseCom";
import DataTable from "../common/DataTable";
import Icon from "../common/Icon";
import Tick from "../common/Tick";
import { withParamsAndNavigate } from "../common/WithParamsAndNavigate";
import { NavMenuGlobal } from "../NavMenu";

class SyncStatusList extends BaseCom {

    async componentDidMount() {
        NavMenuGlobal.setPath('Sync Status');
        await this.pull();
    }

    componentWillUnmount() {
        NavMenuGlobal.clearTitle();
    }

    pull = async () => {
        try {
            let j = await qreq.getAsync('/api/syncstatus/list');
            if (j.list)
                this.setState({ list: j.list, refreshDate: Globals.toMDYHMAMPMLocalDateString(new Date(), true) });
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }



    render() {
        return (
            <div className="container-fluid">
                <Tick interval={5000} onTick={this.pull} />
                <p><i>Refreshes automatically: {this.state.refreshDate}</i></p>
                <DataTable
                    columns={[
                        {
                            name: 'isOnline', title: '', valueFunc: row => {
                                return <span className={row.isOnline ? 'text-success' : 'text-muted'}>
                                    <Icon icon="faCircle" />
                                </span>
                            }
                        },
                        { name: 'syncCredentialName', title: 'Client' },
                        {
                            name: 'lastSeenDate', title: 'Last Active', valueFunc: row => {
                                return Globals.toMDYHMLocalDateStringOrDiff(row.lastSeenDate, true, true);
                            }
                        }
                    ]}
                    data={this.state.list || []}
                />
            </div>
        );
    }
}

export default withParamsAndNavigate(SyncStatusList);